/* eslint-disable react/prop-types */
/* eslint-disable no-nested-ternary */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import React from 'react'
import { ThemeProvider } from '@mui/material/styles'
import CssBaseline from '@mui/material/CssBaseline'
import { useRoutes } from 'react-router-dom'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterMoment } from '@mui/x-date-pickers/AdapterMoment'
import theme from '../theme'
import { useModal } from '../hooks/useModal'
import { reactPlugin } from '../applicationInsights'
import ErrorScreen from '../components/ErrorScreen'
import AppInsightsErrorBoundary from '../components/AppInsightsErrorBoundary'

function App({ routes }) {
  const element = useRoutes(routes)
  const { renderModal } = useModal()

  return (
    <AppInsightsErrorBoundary appInsights={reactPlugin} onError={ErrorScreen}>
      <ThemeProvider theme={theme}>
        <div style={{ position: 'relative' }}>
          <CssBaseline />
          <LocalizationProvider dateAdapter={AdapterMoment}>
            {element}
          </LocalizationProvider>
        </div>
        {renderModal()}
      </ThemeProvider>
    </AppInsightsErrorBoundary>
  )
}

export default App
